<template>
  <div>
    <gj-table
        name="storageArgs"
        :data="tableData"
        :columns="columns"
        :show-overflow="false"
        :loading="loading">
      <template v-slot:content="{ row }">
        <div v-if="row.name==='NR'">
          ≤
          <el-input-number v-model="row.content" @change="updateConfig(row)" size="mini" :min="1" :max="5" step-strictly
                           controls-position="right"></el-input-number>
          星
        </div>
        <div v-if="row.name==='NF'">
          ≤
          <el-input-number v-model="row.content" @change="updateConfig(row)" size="mini" :min="1" :max="3" step-strictly
                           controls-position="right"></el-input-number>
          星
        </div>
        <div v-if="row.name==='MATCH_ORDER_COUNT'">
          匹配订单数 ≤
          <gj-input v-model="row.content" @change="updateConfig(row)"></gj-input>
        </div>
      </template>
    </gj-table>
  </div>
</template>

<script>
import {queryMixin, responseMixin} from "@/minxins";
import {reviewConfigGet, reviewConfigPut} from "@/api/setting";
import {isMeaningful} from "@/utils/common";

export default {
  name: "app-crm-task",
  mixins: [queryMixin, responseMixin],
  data() {
    return {
      tableData: [],
      columns: [
        {
          id: 'name', header: '参数名称', field: 'option:name', minWidth: '200px', options: [
            {id: 'NR', text: '生成NR邮件任务的Review'},
            {id: 'NF', text: '生成NF邮件任务的Feedback'},
            {id: 'MATCH_ORDER_COUNT', text: '差评生成多条NR邮件任务'},
          ]
        },
        {id: 'content', header: '配置项', field: 'slot:content', minWidth: '200px'},
        {id: 'memo', header: '指标配置说明', field: 'memo', minWidth: '400px'},
        {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
      ],
      content: ''
    }
  },
  methods: {
    updateConfig(row) {
      // row.content = row.content==0?'0':row.content
      let re = /^[1-9]+[0-9]*]*$/;
      //若输入值不为空或0，且不为正整数，则退回原值
      if (row.content!=0&&!re.test(row.content)) {
        row.content = this.content;
      }else {
        // 若输入值为空或0，则为1，否则不变
        row.content = row.content==0?1:row.content;
        reviewConfigPut({
          id: row.id.toString(),
          memo: row.memo,
          content: row.content.toString()
        })
            .then((res) => {
              this.content = row.content;
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('更新成功');
              });
            }).complete(() => {
          this.$gjQuery();
        })
      }

    },
    $gjQuery() {
      // 查询
      this.loading = true;
      // this.tableData = [
      //   {
      //     content: "0",
      //     id: 285116,
      //     memo: "差评生成多条NR邮件任务",
      //     name: "MATCH_ORDER_COUNT",
      //     updateTime: "2021-11-05 09:43:24"
      //   },
      //   {
      //     content: "3",
      //     id: 284861,
      //     memo: "生成NF邮件任务的Feedback默认值显示3星",
      //     name: "NF",
      //     updateTime: "2021-11-05 09:43:21"
      //   },
      //   {
      //     content: "3",
      //     id: 284606,
      //     memo: "生成NR邮件任务的Review默认值显示3星",
      //     name: "NR",
      //     updateTime: "2021-11-05 09:43:19"
      //   }
      // ];
      reviewConfigGet()
          .then((data) => {
            if (isMeaningful(data.data)) {
              this.tableData = data.data;
              this.content= this.tableData.find(r=>r.name==='MATCH_ORDER_COUNT').content;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<style scoped>

</style>